var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 7.36255V16.85C0.75 17.4851 1.26491 18 1.9 18H16.85C17.4851 18 18 17.4851 18 16.85V6.50005C18 6.18236 17.7427 5.92505 17.425 5.92505H13.6875",
    fill: "#4C506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.37505C18 9.05736 17.7427 8.80005 17.425 8.80005H2.1875C1.39371 8.80005 0.75 8.15634 0.75 7.36255C0.75 6.56876 1.39371 5.92505 2.1875 5.92505H17.425C17.7427 5.92505 18 6.18236 18 6.50005V9.37505Z",
    fill: "#363A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18755 6.7876C1.86986 6.7876 1.61255 7.04491 1.61255 7.3626V8.67877C1.78879 8.75582 1.98285 8.8001 2.18755 8.8001H17.425V6.7876H2.18755Z",
    fill: "#2C2F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9812 7.3625H3.1937C2.95565 7.3625 2.76245 7.1693 2.76245 6.93125C2.76245 6.6932 2.95565 6.5 3.1937 6.5H14.9812C15.2193 6.5 15.4125 6.6932 15.4125 6.93125C15.4125 7.1693 15.2193 7.3625 14.9812 7.3625Z",
    fill: "#4C506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.375C11.7567 9.375 13.6875 7.44423 13.6875 5.0625C13.6875 2.68077 11.7567 0.75 9.375 0.75C6.99327 0.75 5.0625 2.68077 5.0625 5.0625C5.0625 7.44423 6.99327 9.375 9.375 9.375Z",
    fill: "#F6B940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 0.75C6.99335 0.75 5.0625 2.68085 5.0625 5.0625C5.0625 6.03482 5.38824 6.92866 5.93075 7.65H10.2375C10.8726 7.65 11.3875 7.13509 11.3875 6.5V1.24967C10.7863 0.9317 10.1024 0.75 9.375 0.75Z",
    fill: "#FAD85D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50005 5.0625H5.92505C5.92505 6.96489 7.47266 8.5125 9.37505 8.5125V7.9375C7.78977 7.9375 6.50005 6.64777 6.50005 5.0625Z",
    fill: "#FCE797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.61255V2.18755C10.9603 2.18755 12.25 3.47727 12.25 5.06255H12.825C12.825 3.16016 11.2774 1.61255 9.375 1.61255Z",
    fill: "#FCE797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3874 4.2001C11.3874 3.56587 10.8716 3.0501 10.2374 3.0501V2.4751H9.6624V3.0501H9.3749V2.4751H8.7999V3.0501H7.6499V3.6251H8.2249V6.5001H7.6499V7.0751H8.7999V7.6501H9.3749V7.0751H9.6624V7.6501H10.2374V7.0751C10.8716 7.0751 11.3874 6.55932 11.3874 5.9251C11.3874 5.5801 11.2316 5.27362 10.9901 5.0626C11.2316 4.85157 11.3874 4.5451 11.3874 4.2001ZM10.8124 5.9251C10.8124 6.24221 10.5545 6.5001 10.2374 6.5001H8.7999V5.3501H10.2374C10.5545 5.3501 10.8124 5.60799 10.8124 5.9251ZM8.7999 4.7751V3.6251H10.2374C10.5545 3.6251 10.8124 3.88299 10.8124 4.2001C10.8124 4.51721 10.5545 4.7751 10.2374 4.7751H8.7999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76245 8.80005V15.125C2.76245 15.7601 3.27736 16.275 3.91245 16.275H18V9.37505C18 9.05736 17.7426 8.80005 17.425 8.80005H13.6875",
    fill: "#787FAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 11.675H15.4126C14.6188 11.675 13.9751 12.3188 13.9751 13.1125C13.9751 13.9063 14.6188 14.55 15.4126 14.55H18.0001",
    fill: "#4C506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4124 13.6876C15.73 13.6876 15.9874 13.4302 15.9874 13.1126C15.9874 12.795 15.73 12.5376 15.4124 12.5376C15.0948 12.5376 14.8374 12.795 14.8374 13.1126C14.8374 13.4302 15.0948 13.6876 15.4124 13.6876Z",
    fill: "#363A4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3938 10.2375H4.34385C4.1058 10.2375 3.9126 10.0443 3.9126 9.80625C3.9126 9.5682 4.1058 9.375 4.34385 9.375H12.3938C12.6319 9.375 12.8251 9.5682 12.8251 9.80625C12.8251 10.0443 12.6319 10.2375 12.3938 10.2375Z",
    fill: "#9DA1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4188 15.6999H8.36875C8.1307 15.6999 7.9375 15.5067 7.9375 15.2687C7.9375 15.0306 8.1307 14.8374 8.36875 14.8374H16.4188C16.6568 14.8374 16.85 15.0306 16.85 15.2687C16.85 15.5067 16.6568 15.6999 16.4188 15.6999Z",
    fill: "#9DA1BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPay);
export default __webpack_public_path__ + "static/media/WalletPay.c7fc163cc41397cf8d1b8b1e9a1738a4.svg";
export { ForwardRef as ReactComponent };